import { Site } from '@envato/foundation-types'
import noIndexAllowList from './noIndexAllowList'
import defaultConfig from './defaults'

export default {
  name: '3DOcean',
  abbreviation: '3D',
  domain: '3docean.net',
  google_analytics_id: 'UA-11834194-2',
  google_remarketing_label: '24jqCK2CugMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. low poly building',
  displayCategoryPage: false,
  filters: {
    aggregations: {
      poly_count: {
        min: 4000,
        max: 10000,
        avg: 5000
      }
    }
  },
  features: {},
  forced_features: {
    /**
     * @description Adjustments for "homePageCopyUpdates" experiment, sets winning features for some sites
     * @author Pawel
     * @expires when "homePageCopyUpdates" experiment is over
     */
    ogCopyVerbatim: true,
    combinedCopyNoDollars: false,
    combinedCopyWithDollars: false
  },
  noIndex: noIndexAllowList({
    site: Site.threedocean,
    routes: defaultConfig.noIndex.routes,
    params: defaultConfig.noIndex.params
  })
}
